import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-video', 'play', 'Mängi videot');
